
import { RowExtraDto } from "@/dtos";
import { Extra } from "@/entities";

export const formatTableExtraDto = async (extra: Extra[]): Promise<RowExtraDto[]> => {
    return extra.map((x) => {
        const row: RowExtraDto = {
            ...x,
            is_active: true
        }
        return row;
    });
}